Ext.define('SA.HistogramGeoUnits', {
    singleton: true,

    getSupportedDiscoverableUnits({location, attribute, discoverableUnits}) {
        var supportedUnits = this.getSupportedUnits({location, attribute});

        return Ext.Array.intersect(supportedUnits, discoverableUnits);
    },

    getSupportedDiscoverableUnitsForModel(model) {
        var location = model.getLocation(),
            attribute = model.getAttribute(),
            discoverableUnits = model.getDiscoverableGeoUnits();

        return this.getSupportedDiscoverableUnits({location, attribute, discoverableUnits});
    },

    getSupportedUnits({location, attribute}) {
        var location = SA.data.LocationsCache.toLocationSeries(location),
            locationUnit = SA.data.LocationsCache.getGeographicUnit(location),
            allowedUnits = SA.data.GeographicUnits.getAllowedIds({location, attribute});

        return allowedUnits.filter(unit => unit !== locationUnit);
    },

    resolveUnit({location, attribute, preferredUnit, discoverableUnits}) {
        var supportedUnits = this.getSupportedUnits({location, attribute}),
            supportedDiscoverableUnits = this.getSupportedDiscoverableUnits({location, attribute, discoverableUnits}),
            defaultUnit = supportedDiscoverableUnits[0] || null;

        return supportedUnits.includes(preferredUnit) ? preferredUnit : defaultUnit;
    }
});